module.exports = __webpack_public_path__ + "230f8e4ac4a5686331f5a1ece18cc7ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/authors/images/atm.png
// module id = 850
// module chunks = 3